export var appsActiveTabs = {
    gmail: 'gmail',
    drive: 'drive',
    meet: 'meet',
    chat: 'chat',
    gemini: 'gemini',
    searchMeetings: 'search-meetings',
    driveAdvancedSearch: 'drive-advanced-search',
    eventsLog: 'events-log'
};
export var settingsActiveTabs = {
    general: 'general',
    users: 'users',
    billing: 'billing',
    activityLabels: 'activity-labels'
};
export var profileActiveTabs = {
    profile: 'profile'
};
export var docAlertsActiveTabs = {
    alerts: 'alerts',
    configuration: 'configuration'
};
